module.exports = {
      id: "wave-usage",
      viewBox: "0 0 64 6",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#wave-usage",
      toString: function () {
        return this.url;
      }
    }